import type { HotWaterTileWidget } from '../../../widgets';
import {
  BindingRow,
  CheckboxField,
  OptionalBindingRow,
  Section,
  TextField,
  patcher,
  type WidgetEditorProps,
} from '../fields';
import { AiHintSection } from './AiHintSection';

export function HotWaterTileEditor(
  { widget, plantId, missing, onChange }: WidgetEditorProps<HotWaterTileWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Speicher">
        <TextField
          label="Name des Speichers"
          value={widget.storageName}
          keepEmptyString
          required
          missing={missing.has('storageName')}
          placeholder="Pufferspeicher 300 L"
          onChange={(next) => patch({ storageName: next ?? '' })}
        />
      </Section>

      <Section
        title="Schichtung"
        hint="Oben ist die betrieblich wichtige Temperatur: das ist, was am Hahn ankommt."
      >
        <BindingRow
          label="Temperatur oben"
          value={widget.topTemperaturePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ topTemperaturePoint: next })}
        />
        <OptionalBindingRow
          label="Temperatur Mitte"
          value={widget.midTemperaturePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ midTemperaturePoint: next })}
        />
        <OptionalBindingRow
          label="Temperatur unten"
          value={widget.bottomTemperaturePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ bottomTemperaturePoint: next })}
        />
      </Section>

      <Section title="Sollwert und Betrieb">
        <BindingRow
          label="Sollwert"
          value={widget.setpointPoint}
          plantId={plantId}
          filter={{ valueType: 'number', writable: widget.setpointWritable !== false }}
          onChange={(next) => patch({ setpointPoint: next })}
        />
        <CheckboxField
          label="Sollwert verstellbar"
          checked={widget.setpointWritable !== false}
          onChange={(next) => patch({ setpointWritable: next })}
        />
        <OptionalBindingRow
          label="Ladezustand"
          value={widget.statePoint}
          plantId={plantId}
          filter={{ valueType: 'enum' }}
          hint="Bereit, Lädt, Legionellen, Störung."
          onChange={(next) => patch({ statePoint: next })}
        />
        <OptionalBindingRow
          label="Nächster Legionellen-Lauf"
          value={widget.nextLegionellaPoint}
          plantId={plantId}
          hint="Zeitstempel vom Regler. Die Kachel macht daraus die Angabe in Tagen."
          onChange={(next) => patch({ nextLegionellaPoint: next })}
        />
      </Section>

      <AiHintSection value={widget.ai} onChange={(next) => patch({ ai: next })} />
    </>
  );
}
